import { Button, Card } from "react-bootstrap"
import { useTranslation } from "../../hooks/use-translation"
import { LanguageSwitcher } from "../../components/language-switcher"
import { Link } from "react-router-dom"
import { CheckCircle } from "lucide-react"

export default function PendingApprovalPage() {
  const { t } = useTranslation()

  return (
    <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center bg-light p-3">
      <div className="position-absolute top-0 end-0 p-3">
        <LanguageSwitcher />
      </div>
      <div className="mb-4 d-flex align-items-center gap-2">
        <img
          src="/logo.svg?height=40&width=40"
          alt="UnitySmartLiving Logo"
          width={40}
          height={40}
          className="rounded"
        />
        <span className="fs-3 fw-bold">UnitySmartLiving</span>
      </div>
      <Card className="w-100" style={{ maxWidth: "400px" }}>
        <Card.Header className="text-center">
          <div className="d-flex flex-column align-items-center">
            <CheckCircle className="mb-2 size-4 text-success" style={{ width: "64px", height: "64px" }} />
            <Card.Title>{t("registrationComplete")}</Card.Title>
          </div>
        </Card.Header>
        <Card.Body className="text-center">
          <p className="mb-4">{t("pendingApprovalMessage")}</p>
          <Link to="/auth/login">
            <Button variant="outline-primary">{t("backToLogin")}</Button>
          </Link>
        </Card.Body>
      </Card>
    </div>
  )
}
